export { default } from './Renegociacao25EmpDDA';
